import React from 'react';
import { FaEdit, FaClone, FaTrash } from 'react-icons/fa';

const formatCamelCase = (text) => {
  if (!text) return "";
  return text
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, char => char.toUpperCase());
};

export const getRolesColumns = ({ handleEdit, handleClone, handleDelete, hasPermission }) => [
  {
    accessorKey: 'index',
    header: '#',
    cell: (info) => <span className="opacity-50 text-white">{info.row.index + 1}</span>,
    enableSorting: false,
  },
  {
    accessorKey: 'roleName',
    header: 'Role Title',
    cell: (info) => <span className="fw-bold text-white">{info.getValue()}</span>,
  },
  {
    accessorKey: 'projectName',
    header: 'Project',
    cell: (info) => <span className="text-warning fw-bold">{formatCamelCase(info.getValue())}</span>,
  },
  {
    accessorKey: 'roleCategory',
    header: 'Category',
    cell: (info) => <span className="text-capitalize">{formatCamelCase(info.getValue())}</span>,
  },
  {
    accessorKey: 'auditionType',
    header: 'Mode',
    cell: (info) => <span className="small">{formatCamelCase(info.getValue())}</span>,
  },
  {
    accessorKey: 'roleLocation',
    header: 'Location',
  },
  {
    accessorKey: 'totalApplicants',
    header: 'Applicants',
    cell: (info) => <span className="text-warning fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'pendingCount',
    header: 'Pending',
    cell: (info) => <span className="text-primary fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'selectedCount',
    header: 'Selected',
    cell: (info) => <span className="text-success fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'rejectedCount',
    header: 'Rejected',
    cell: (info) => <span className="text-danger fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: (info) => {
      const val = info.getValue();
      const isInactive = String(val).toLowerCase() === 'inactive';
      return (
        <span className={`mrp-status-tag ${isInactive ? 'mrp-status-inactive' : 'mrp-status-active'}`}>
          {val}
        </span>
      );
    },
  },
  {
    id: 'actions',
    header: () => <div style={{ textAlign: "center", width: "100%" }}>ACTIONS</div>,
    enableSorting: false,
    cell: (info) => {
      const role = info.row.original;
      return (
        <div className="mrp-action-btn-group">
          {hasPermission('Roles', 'Edit') && (
            <button 
              type="button" 
              className="mrp-btn-action mrp-btn-edit" 
              title="Edit Role" 
              onClick={() => handleEdit(role.id)}
            >
              <FaEdit size={13} color="#ffffff" />
            </button>
          )}
          {hasPermission('Roles', 'Clone') && (
            <button 
              type="button" 
              className="mrp-btn-action mrp-btn-clone" 
              title="Clone Role" 
              onClick={() => handleClone(role)}
            >
              <FaClone size={13} color="#ffffff" />
            </button>
          )}
          {hasPermission('Roles', 'Delete') && (
            <button 
              type="button" 
              className="mrp-btn-action mrp-btn-delete" 
              title="Delete Role" 
              onClick={() => handleDelete(role)}
            >
              <FaTrash size={13} color="#ffffff" />
            </button>
          )}
        </div>
      );
    },
  }
];
